import { a as r } from "./an-object.js";
import { i as o } from "./is-object.js";
import "./new-promise-capability.js";
import { __exports as i } from "../../../_virtual/new-promise-capability.js";
var s = function s(_s, e) {
  if (r(_s), o(e) && e.constructor === _s) return e;
  var t = i.f(_s);
  return (0, t.resolve)(e), t.promise;
};
export { s as p };